module.exports = __webpack_public_path__ + "static/media/16_plantilla_rec_combo_simple_cp_gaseosas_lata_220_spsa.eb05ffa7.png";